// extracted by mini-css-extract-plugin
export default {"badgeStrip":"BadgeStrip_badgeStrip__LQj2J"};